export function downloadJsonFile(payload, filename = 'atlas_export.json') {
    const blob = new Blob([JSON.stringify(payload, null, 2)], {
        type: 'application/json',
    })

    const url = URL.createObjectURL(blob)

    const a = document.createElement('a')
    a.href = url
    a.download = filename

    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)

    URL.revokeObjectURL(url)
}

export async function downloadExcelWorkbook(workbook, filename = 'atlas_export.xlsx') {
    const buffer = await workbook.xlsx.writeBuffer()

    const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    })

    const url = URL.createObjectURL(blob)

    const a = document.createElement('a')
    a.href = url
    a.download = filename

    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)

    URL.revokeObjectURL(url)
}

export function safeFilename(value, fallback = 'atlas_export') {
    const cleaned = String(value || fallback)
        .replace(/[<>:"/\\|?*]+/g, '')
        .replace(/\s+/g, '_')
        .trim()

    return cleaned || fallback
}
